


























































import { Component, Prop, Vue } from 'vue-property-decorator'
import rdfUtils from '@/rdf/utils'

@Component
export default class SearchResultList extends Vue {
  @Prop({ default: null })
  readonly results: any

  @Prop({ default: null })
  readonly totalCount: number

  pathTerm(term): string {
    return rdfUtils.pathTerm(term)
  }
}
